import script from "./AdminForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminForm.vue?vue&type=script&setup=true&lang=js"

import "./AdminForm.vue?vue&type=style&index=0&id=b73e7884&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b73e7884"]])

export default __exports__